module.exports = __webpack_public_path__ + "static/media/cogent-associates.ef3afe4f.png";